import { SVGProps } from 'react'

export const ArrowUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='12'
    viewBox='0 0 10 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M8.70824 4.50001L4.95824 0.750015M4.95824 0.750015L1.20824 4.50001M4.95824 0.750015L4.95824 11.25'
      stroke='currentColor'
      strokeWidth='1'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
